import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { BUDGET } from "./apiRoutes";

const mutateSubmitForApproval = async ({
  communityId,
  budgetId,
  reason,
}: {
  communityId: string;
  budgetId: string;
  reason: string;
}) => {
  return await axiosAuth.post(
    `${BUDGET(communityId)}/${budgetId}/submit?reason=${encodeURIComponent(reason)}`
  );
};

const useSubmitForApprovalMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      communityId: string;
      budgetId: string;
      reason: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateSubmitForApproval,
    ...queryParams,
  });

export default useSubmitForApprovalMutation;
